import { faPlay } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  ExternalLink,
  ModalConfirmV2,
  ModalSizeVariants,
} from '@labrav/react-components'
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import { useStyles } from './ProductVideoAction.styles'

interface VideoModalProps {
  actionTitle: string
  actionLable: string
  videoLink: string
  isVideoModalOpen: boolean
  setIsVideoModalOpen: Dispatch<SetStateAction<boolean>>
}

const aspectRatio = 16 / 9

export const VideoModal = ({
  isVideoModalOpen,
  setIsVideoModalOpen,
  actionTitle,
  actionLable,
  videoLink,
}: VideoModalProps) => {
  const { classes } = useStyles()

  const [isPlaying, setIsPlaying] = useState<boolean>(false)

  const containerRef = useRef<HTMLDivElement | null>(null)

  const [iframeHeight, setIframeHeight] = useState(0)

  const handleClick = async (event: any) => {
    setIsPlaying(true)
  }
  const handleCloseModal = () => {
    setIsVideoModalOpen(false)
  }
  const paddingBottom = `${100 / aspectRatio}%`

  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current && containerRef.current.offsetWidth) {
        const width = containerRef.current.offsetWidth
        setIframeHeight(width * aspectRatio)
      }
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  return (
    <ModalConfirmV2
      title={`${actionTitle}${actionLable}`}
      content={
        <div className={classes.videoWrapper}>
          <div
            style={{
              height: iframeHeight,
              cursor: 'pointer',
              position: 'relative',
              paddingBottom,
            }}
            onClick={!isPlaying ? handleClick : undefined}
          >
            <iframe
              height="100%"
              width="100%"
              src={videoLink}
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
              }}
            ></iframe>
          </div>
          <ExternalLink children={'Open video in new tab'} href={videoLink} />
        </div>
      }
      open={isVideoModalOpen}
      hideCancelButton={true}
      hideAcceptButton={true}
      onDecline={handleCloseModal}
      onAccept={handleCloseModal}
      variant={ModalSizeVariants.large}
      icon={<FontAwesomeIcon style={{ height: '12px' }} icon={faPlay} />}
    />
  )
}
